<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <b-row align-h="start">
            <b-col cols="3"> <v-select :value="program" v-model="program" :options="formatOptions"></v-select>
            </b-col>

            <b-col cols="12" md="auto"><vs-button style="border-radius: 5px" color="success" @click="satisListesi()"
                type="filled">Listele</vs-button>


            </b-col>
            <b-col cols="12" md="auto"><vs-button style="border-radius: 5px" @click="yazdir()"
                type="gradient">Yazdır</vs-button>
            </b-col>
            <b-col cols="12" md="auto"><vs-button style="border-radius: 5px" type="gradient" color="danger"
                id="button-with-loading-excel" class="vs-con-loading__container">
                <download-excel class="btn btn-default" :data="data" name="excelData.xls"
                  style="padding: 0px !important; color: white">
                  Excel
                </download-excel>
              </vs-button>
            </b-col>
          </b-row>

        </vx-card>

        <vs-table :data="data">
          <template slot="thead">
            <vs-th>Stok Kodu</vs-th>
            <vs-th>Stok Adı</vs-th>
            <vs-th>Satış Adet</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ data[indextr].stokKodu }}
              </vs-td>

              <vs-td>
                {{ data[indextr].productName }}
              </vs-td>
              <vs-td>
                {{ data[indextr].satisAdet }}
              </vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td></vs-td>
              <vs-td>Toplam</vs-td>
              <vs-td>{{ toplama() }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <div id="printMe" style="height:200px; overflow:scrool; width:100%;">
      <template id="app">
        <table border="1px;" style="width:100%">
          <tr>
            <td align="right">
              {{ getNow() }}
            </td>
          </tr>
          <tr>
            <td></td>
          </tr>
        </table>
      </template>
      <template>
        <table style="width:100%!important">
          <tr>
            <th sort-key="stokkodu" style="border:1px solid black; padding:3px">
              Stok Kodu
            </th>
            <th style="border:1px solid black; padding:3px">Stok Adı</th>

            <th style="border:1px solid black; padding:3px">Adet</th>
            <th style="border:1px solid black; padding:3px">Toplam</th>
          </tr>

          <tr :key="indextr" v-for="(tr, indextr) in data">
            <td style="border:1px solid black; padding:3px">
              {{ tr.stokKodu }}
            </td>
            <td style="border:1px solid black; padding:3px">
              {{ tr.productName }}
            </td>

            <td style="border:1px solid black; padding:3px">
              {{ tr.Toplam }}
            </td>
          </tr>

          
        </table>
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import state from "../../store/state";
import Store from "../../store/store";
export default {
  data() {
    return {
      format: "yyyy-MM-dd",
      data: [],
      baslangic: "",
      formattedDate: "",
      formattedDate1: "",
      bitis: "",
      program: { id: 0, label: "Pazaryeri" },
      check3: "",
      formatOptions: []
    };
  },
  created() {
    this.tabList = Store.state.uzum.menuListForTabs;
    this.tabList.forEach((val, index) => {
      this.formatOptions.push({ label: val.name, id: val.name });
    });
  },
  methods: {
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    yazdir() {
      this.$htmlToPaper("printMe");
    },
    toplama() {
      var vm = this;
      var sayi = 0;
      this.data.forEach(element => {
        sayi = sayi + parseInt(element.satisAdet);
      });
      return sayi;
      // this.toplam=parseInt(this.toplam)+parseInt(d)
      // return this.toplam
      //console.log(this.toplam)
    },
    satisListesi() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      // console.log(vm.formattedDate)
      let today = new Date();
      const args = {
        program: this.program.label,
        baslik: "stokRaporuBekleyen",
        tarih1: moment(String(today)).format("DD.MM.YYYY"),
        tarih2: moment(String(today)).format("DD.MM.YYYY"),
        token: Store.state.tokenId,
        kullaniciId: "",
        siparisNo: ""
      };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.standartSorguRapor(args, function (err, result) {
          if (result.standartSorguRaporResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.standartSorguRaporResult);
          // console.log(vm.veriler)
          vm.data = vm.veriler;
          // vm.eslesenStokListesi=vm.veriler
        });
      });
    }
  },
  components: {
    "v-select": vSelect,
    Datepicker
  }
};
</script>
